export const AIRINGS = `
    query Airings (
        $countryCode: String!,
        $deviceType: DeviceType!,
        $tz: String!,
        $type: AiringType,
        $categories: [String],
        $networks: [String],
        $packages: [String],
        $eventId: String,
        $packageId: String,
        $start: String,
        $end: String,
        $day: String,
        $limit: Int
    ) {
        airings(
            countryCode: $countryCode,
            deviceType: $deviceType,
            tz: $tz,
            type: $type,
            categories: $categories,
            networks: $networks,
            packages: $packages,
            eventId: $eventId,
            packageId: $packageId,
            start: $start,
            end: $end,
            day: $day,
            limit: $limit
        ) {
            id
            airingId
            simulcastAiringId
            name
            type
            startDateTime
            shortDate: startDate(style: SHORT)
            authTypes
            adobeRSS
            duration
            feedName
            purchaseImage {
                url
            }
            image {
                url
            }
            network {
                id
                type
                abbreviation
                name
                shortName
                adobeResource
                isIpAuth
            }
            source {
                url
                authorizationType
                hasPassThroughAds
                hasNielsenWatermarks
                hasEspnId3Heartbeats
                commercialReplacement
            }
            packages {
                name
            }
            category {
                id
                name
            }
            subcategory {
                id
                name
            }
            sport {
                id
                name
                abbreviation
                code
            }
            league {
                id
                name
                abbreviation
                code
            }
            franchise {
                id
                name
            }
            program {
                id
                code
                categoryCode
                isStudio
            }
            tracking {
                nielsenCrossId1
                nielsenCrossId2
                comscoreC6
                trackingId
            }
        }
    }
`;

export const AIRING = `
    query Airing (
        $id: ID!,
        $countryCode: String!,
        $deviceType: DeviceType!,
        $tz: String!
    ) {
        airing(
            id: $id,
            countryCode: $countryCode,
            deviceType: $deviceType,
            tz: $tz
        ) {
            id
            airingId
            simulcastAiringId
            name
            type
            startDateTime
            shortDate: startDate(style: SHORT)
            authTypes
            adobeRSS
            duration
            feedName
            image {
                url
            }
            network {
                id
                type
                abbreviation
                name
                shortName
                adobeResource
                isIpAuth
            }
            source {
                url
                authorizationType
                hasPassThroughAds
                hasNielsenWatermarks
                hasEspnId3Heartbeats
                commercialReplacement
            }
            packages {
                name
            }
            category {
                id
                name
            }
            subcategory {
                id
                name
            }
            sport {
                id
                name
                abbreviation
                code
            }
            league {
                id
                name
                abbreviation
                code
            }
            franchise {
                id
                name
            }
            program {
                id
                code
                categoryCode
                isStudio
            }
            tracking {
                nielsenCrossId1
                nielsenCrossId2
                comscoreC6
                trackingId
            }
        }
    }
`;

export const VOD = `
    query VOD(
        $countryCode: String!,
        $deviceType: DeviceType!,
        $tz: String!,
        $packageId: String,
        $id: ID!
    ) {
        VOD(
            countryCode: $countryCode,
            deviceType: $deviceType,
            tz: $tz,
            $packageId: String,
            id: $id
        ) {
            id
            name
            origination
            originalPublishDate
            embargoDate
            expirationDate
            lastModifiedDate
            image {
                url
            }
            description
            source {
                url
                authorizationType
            }
            category {
                id
                name
            }
            subcategory {
                id
                name
            }
            sport {
                id
                name
                abbreviation
                code
            }
            league {
                id
                name
                abbreviation
                code
            }
            links {
                web
            }
            tracking {
                name
                sportName
                leagueName
            }
            ad {
                sport
                bundle
            }
            coverageType
            authTypes
            duration
        }
    }
`;

export const NETWORKS = `
    query Networks(
        $countryCode: String!
    ) {
        networks(
            countryCode: $countryCode
        ) {
            id
            name
            abbreviation
            shortName
            adobeResource
            type
            isActive
            isIpAuth
        }
    }
`;



// WEBPACK FOOTER //
// ./app/queries.js